import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { UseAdvertFavoriteVisibleControlResultType, useAdvertFavoriteState } from '#advertFavorite/hooks';
import { favoriteHide, favoriteOpen } from '#advertFavorite/reducers';

const useAdvertFavoriteVisibleControl = (): UseAdvertFavoriteVisibleControlResultType => {
  const { isOpen } = useAdvertFavoriteState();
  const dispatch = useDispatch();

  const triggerOpen = useCallback(() => {
    dispatch(favoriteOpen());
  }, [dispatch]);

  const triggerHide = useCallback(() => {
    dispatch(favoriteHide());
  }, [dispatch]);

  return {
    isOpen,
    open: triggerOpen,
    hide: triggerHide,
  };
};

export { useAdvertFavoriteVisibleControl };
